import React, { useState } from "react";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Landing from "../Landing/Landing";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import SideBar from "../SideBar/SideBar";
import fsTopIcon from "../../image/newImg/fs.png";
import "./Content.css";
function Faculty(props) {
  const {
    cover,
    sidebar_data,
    data,
    title,
    alumni_data,
    curriculum_data,
    side_heading,
    side_sub_heading,
  } = props;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const handleScroll = (e) => {
    console.log("asd");
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);
    console.log(isShow);
  };

  return (
    <div className="content_main" onScroll={handleScroll}>
      <Navbar isScrolled={isScrolled} handleClick={handleClick} />
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      <Landing video={false} cover={cover} />
      <div className="contentmain_cont">
        <div style={{ width: "min-content" }}>
          <SideBar
            sidebar_data={sidebar_data}
            side_heading={side_heading}
            side_sub_heading={side_sub_heading}
          />
          <Contact />
        </div>
        <div>
          <div className={`f-2 f-500 mb-3`} style={{ color: "#0076BD" }}>
            <img
              src={fsTopIcon}
              style={{ width: "4rem", marginRight: "1rem" }}
            />
            Faculty & Staff
          </div>
          <div>
            <div className="d-flex gap-2 mt-1">
              <div>
                {/* <div className="f-bold f-1-2 mb-2"></div> */}
                <div className="color-grey f-500">
                  HGS Bhimtal has a very experienced,
                  knowledgeable, well-qualified and dedicated Staff, so much so
                  that they are conscious of their responsibility of being the
                  most important block in the foundation of the Nation as well
                  as the Society.
                </div>
                <div className="color-grey f-500 mt-2">
                  Their self-discipline is an example in itself, which always
                  drives them to work as a well-knit team to make all possible
                  endeavour together for the holistic growth of students as well
                  the institution. They are enthusiastic, dedicated,
                  conscientious and highly motivated to adapt to new innovative
                  ideas and well versed with modern education systems.
                </div>
                <div className="color-grey f-500 mt-2">
                  The valuable contribution of all the Faculty members is well
                  manifested in the spectacular achievements of our students in
                  the scholastic as well as co- scholastic discipline.
                </div>
                <div className="color-grey f-500 mt-2">
                  The Teachers grouped under various subject-wise Faculties are
                  put under the guidance of the most experienced Faculty heads.
                  All of them always put their heads together to devise
                  improvised methodology to deliver their best to facilitate the
                  young evolving minds. This significantly contributes in
                  promoting the problem solving skills of students to enable
                  them to grow as useful citizens.
                </div>
              </div>
            </div>
          </div>
          <div className="faculty_staff">
            <div className="gap-2 mt-3">
              <div>
                <div className="text-center f-bold f-1-2 mb-4 ">
                  HGS BHIMTAL (NAINI TAL) UK <br />
                  DETAILS OF TEACHING STAFF (2025-26)
                </div>
                <div className="text-left">
                  <table className="table table-striped table-bordered">
                    <thead style={{
                      backgroundColor: '#0076bd',
                      color: 'white'
                    }}>
                      <tr>
                        <th scope="col">Sr.</th>
                        <th scope="col">Teacher's Name</th>
                        <th scope="col">Qualifications</th>
                        <th scope="col">Designation</th>
                      </tr>
                    </thead>
                    <tbody>
                     <tr><td>1</td><td>MRS. MAHIMA BHATT</td><td>M.Sc, M.A. B.Ed.</td><td>Principal</td></tr>
<tr><td>2</td><td>MS. ANUSUYA SAH</td><td>M.Com, B.Ed.</td><td>HM/PGT B STUDIES</td></tr>
<tr><td>3</td><td>Mrs. ANANTIKA PANDEY</td><td>M.A.(English) B.Ed.</td><td>PGT(English)</td></tr>
<tr><td>4</td><td>Dr. YOGITA VERMA</td><td>M.A.(Fine Art) M.Ed. Ph.D</td><td>PGT(Painting)</td></tr>
<tr><td>5</td><td>MRS. JAYA NEGI</td><td>M.A.(Hindi) B.Ed.,UTET -II</td><td>PGT(Hindi)</td></tr>
<tr><td>6</td><td>MR. UMESH CH. JOSHI</td><td>M.Sc. (Maths) B.Ed.</td><td>PGT(Maths)</td></tr>
<tr><td>7</td><td>MR. KAMLESH SINGH KANYAL</td><td>M.Sc. (Physics), B.Ed.</td><td>PGT (Physics)</td></tr>
<tr><td>8</td><td>MR. RAM KRISHAN SHARMA</td><td>M.Com, B.Ed.</td><td>PGT (Accountancy)</td></tr>
<tr><td>9</td><td>MR. KAMAL KISHOR PATHAK</td><td>M.Sc. (Zoology) B.Ed.</td><td>PGT (Bio.)</td></tr>
<tr><td>10</td><td>MR. ALFONSO</td><td>M.A. (English), B.Ed.</td><td>PGT (Eng)</td></tr>
<tr><td>11</td><td>MR. SUDHIR KUNDU</td><td>M.P.Ed.</td><td>PGT (Phy.Edu)</td></tr>
<tr><td>12</td><td>MR. HIMANSU FARTIYAL</td><td>B.Com., M.P.Ed.</td><td>PGT (Phy. Edu.)</td></tr>
<tr><td>13</td><td>MR. DEEPAK TIWARI</td><td>M.A.B.ED.</td><td>PGT (Geog.)</td></tr>
<tr><td>14</td><td>MR. BIPIN CH. PALARIYA</td><td>MA.Eco., B.Ed</td><td>PGT (Economics)</td></tr>
<tr><td>15</td><td>MR. ASHUTOSH PAL</td><td>M.Sc., B.Ed.</td><td>PGT (Chemistry)</td></tr>
<tr><td>16</td><td>MR. SANJAY SINGH BISHT</td><td>M.Sc. CS</td><td>PGT</td></tr>
<tr><td>17</td><td>MR. PRAKHAR RATHOUR</td><td>MA. POL SCIENCE</td><td>PGT</td></tr>
<tr><td>18</td><td>MS. SANJANA</td><td>MA. PHYCHOLOGY & M.SC.</td><td>COUNSELLOR CUM PGT PHYSCHOLOGY</td></tr>
<tr><td>19</td><td>Ms. MEENA BHAN</td><td>M.Sc.(Maths) B.ED.</td><td>TGT(Maths)</td></tr>
<tr><td>20</td><td>Mrs. INDU BHAKT</td><td>M.A.(Pol Sc.) BED.,VISHARAD</td><td>TGT(Music)</td></tr>
<tr><td>21</td><td>Mr. ARVIND KUMAR</td><td>MCA,MA Eng, B.Ed, M.Sc .</td><td>TGT(Comp)</td></tr>
<tr><td>22</td><td>MS. RICHA MAMGAIN</td><td>M.A. (English), PRABHAKAR</td><td>TGT Music</td></tr>
<tr><td>23</td><td>MR. AMIT KUMAR JOSHI</td><td>M.A. (Hindi)/Sans, B.Ed. UTET</td><td>TGT(Hindi)</td></tr>
<tr><td>24</td><td>MS. SEEMA GERA</td><td>M.A.(Sociology), B.Ed.</td><td>TGT(S.St.)</td></tr>
<tr><td>25</td><td>MRS TARA BISHT</td><td>M.Sc . (Chem.) B.Ed. CTET</td><td>TGT-SCI</td></tr>
<tr><td>26</td><td>MR. ANAND SINGH</td><td>M.A.(English) B.Ed.</td><td>TGT (English)</td></tr>
<tr><td>27</td><td>MR. RAJESH K. TIWARI</td><td>B.Sc.,M.A.(English) B.Ed.</td><td>TGT (SCI)</td></tr>
<tr><td>28</td><td>MR. MUKESH CH. BELWAL</td><td>M.A. (Hindi & Sansk),B.Ed.</td><td>TGT (HINDI)</td></tr>
<tr><td>29</td><td>MS. SUNITA RANI ARORA</td><td>M.A.(Hindi/Sans) B Ed.</td><td>TGT (HINDI)</td></tr>
<tr><td>30</td><td>MR. DEEP CH. JOSHI</td><td>M.Sc. (Maths),B.Ed.</td><td>TGT Maths</td></tr>
<tr><td>31</td><td>MR. RAJAT JOSHI</td><td>M.SC. (CHEM.),B.ED. CTER</td><td>TGT SCIENCE</td></tr>
<tr><td>32</td><td>MS. POOJA KUMARI</td><td>M.P.ED.</td><td>WARDEN CUM COACH</td></tr>
<tr><td>33</td><td>MS. HIMANI OLI</td><td>M.A. ENGLISH, EDU. & B.ED.</td><td>TGT</td></tr>
<tr><td>34</td><td>MR. NIRANJAN SINGH MUNAULA</td><td>M.SC,. B.ED</td><td>TGT</td></tr>
<tr><td>35</td><td>MR. ASHISH KAUL</td><td>B.P.E.</td><td>WELLNESS TEACHER</td></tr>
<tr><td>36</td><td>MRS. SUMAN RAWAT</td><td>M.A. (Hist & Socio.) B.ED. D.L.Ed.</td><td>SPECIAL EDUCATIOR</td></tr>
<tr><td>37</td><td>MR. AMIR</td><td>DIP. IN CSE</td><td>TGT ATAL LAB</td></tr>
<tr><td>38</td><td>MRS. POONAM PANDEY</td><td>B.A. NTT, B.Ed.D.L.Ed</td><td>KG TEACHER</td></tr>
<tr><td>39</td><td>MRS. LEENA BISHT</td><td>B.A. NTT, BED, D.L.ED, CTET</td><td>KG TEACHER</td></tr>
<tr><td>40</td><td>MRS. KIRAN PATWAL</td><td>M.A. B.Ed. D.LED.CTET, UTET</td><td>PRT</td></tr>
<tr><td>41</td><td>MRS MEENAKSHI SINGH</td><td>M.A.(English) THC</td><td>PRT</td></tr>
<tr><td>42</td><td>MRS. JYOTI OJHA</td><td>M.A.(Eco.& Hindi) B.Ed.</td><td>PRT</td></tr>
<tr><td>43</td><td>MISS KALPANA RAWAT</td><td>M.A. (Music), Visharad, D.L.Ed.</td><td>PRT</td></tr>
<tr><td>44</td><td>MRS. BHAWNA SHARMA</td><td>B.Com.,B.ED.</td><td>PRT</td></tr>
<tr><td>45</td><td>MRS. SMITA SRIVASTAVA</td><td>M.A. B.Ed. DLED</td><td>PRT</td></tr>
<tr><td>46</td><td>MR. BHAGWAT SINGH</td><td>PG PHY EDUCATION</td><td>PRT PET</td></tr>
<tr><td>47</td><td>MS. JYOTI</td><td>M.A. (Yoga & Education,B.Ed.</td><td>PRT</td></tr>
<tr><td>48</td><td>MS. TARA JOSHI</td><td>M.A. (ECO),B.Ed</td><td>PRT</td></tr>
<tr><td>49</td><td>MS. ANJALI UPADHYAY</td><td>B.Sc, B.Ed. CTET</td><td>PRT</td></tr>
<tr><td>50</td><td>MS JANKI CHAUNAL</td><td>B.A. NTT</td><td>ASSTT TEACHER</td></tr>
<tr><td>51</td><td>MRS. JYOTI BHATT</td><td>M.COM., MCA, PGDCA</td><td>PRT CS</td></tr>
<tr><td>52</td><td>MS. ANJALI JOSHI</td><td>B.SC, B.ED</td><td>PRT</td></tr>
<tr><td>53</td><td>MR. VINOD CH. JOSHI</td><td>M.A, CERTIFICATE IN LIB Sc,, B.LIB</td><td>LIBRARIAN</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Faculty;
